export function resizedAssetUrl(
	sourceUrl: string,
	options: { width: number; height: number; fit?: 'cover' | 'contain' },
): string {
	const url = new URL(sourceUrl, window.location.origin);

	let dimensions = `${options.width.toFixed()}x${options.height.toFixed()}`;

	if (options.fit) {
		dimensions += `/${options.fit}`;
	}

	url.searchParams.set('d', dimensions);

	return url.toString();
}
